module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.upload($event.target.files)
      }
    }
  })]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.imgUrl,
      "frameborder": "0"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a599732c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutor/TutorImg.vue
// module id = 1438
// module chunks = 0